import { useParams } from 'react-router-dom';
import { useOrganization } from '../../api/hooks/use-organizations';

export function OrganizationBreadcrumb() {
    const { organizationId } = useParams<{ organizationId: string }>();
    const { data: organization } = useOrganization(organizationId ?? '');

    const label = organization?.name ?? organizationId ?? '';

    return <span className="font-medium">{label}</span>;
}
